



































































































































import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import {mapGetters, mapActions} from 'vuex';
import Title from '@/components/Title';
import BannerWithSlot from '@/components/BannerWithSlot';
import InformationCard from '@/components/InformationCard';
import Carousel3D from '@/components/Carousel3D';
import SearchingPanel from '@/components/SearchingPanel';
import ToggleDesign from '@/components/ToggleDesign';
import VLazyImage from 'v-lazy-image';
import Swiper from '@/components/Swiper';
import { PHOTO_ARROW } from '@/components/Icon/icons';
import { arrayIsEmpty } from '@/utils';
import { objectToQuerystring } from '@/services/api';

@Component({
  name: 'AboutDesign',
  components: {
    BannerWithSlot, Carousel3D, InformationCard,
    SearchingPanel, Swiper, Title, ToggleDesign,
    VLazyImage,
  },
  data() {
    return {
      activeSlide: 0,
      swiperOption: {
        height: this.$vuetify.breakpoint.xsOnly ? 260 : '45vw',
        loop: true,
        navigation: {
          class: 'nav-icon',
          icon: PHOTO_ARROW,
        },
        pagination: this.$vuetify.breakpoint.xsOnly,
      },
      actualQuery: {},
      toggleDesignIndex: 0,
    };
  },
  computed: {
    ...mapGetters([
      'searchingPanel',
      'chooseButtonLink',
      'actualSearchData',
    ]),
    ...mapGetters('about', [
      'aboutDesignTexts',
    ]),

    infoCards() {
      return (this as any).aboutDesignTexts.designs[(this as any).toggleDesignIndex];
    },

    slides() {
      return (this as any).aboutDesignTexts
        && (this as any).aboutDesignTexts.designs
          && (this as any).aboutDesignTexts.designs[(this as any).toggleDesignIndex]
            && (this as any).aboutDesignTexts.designs[(this as any).toggleDesignIndex].photos;
    },
  },
  methods: {
    ...mapActions([
      'updateActualSearchData',
    ]),
    sendToApiSearch(data) {
      this.$set(this, 'actualQuery', {...this.actualQuery, ...data});
      this.updateActualSearchData(this.actualQuery);
      this.$router.push({path: `/catalog/?${objectToQuerystring(this.actualQuery)}`});
    },
    srcImg(photo) {
      return photo && `${photo[3600]}` || '';
    },

    srcImgPlaceholder(photo) {
      return photo && `${photo[400]}`;
    },

    srcSet(photo) {
      return photo && `${photo[400]} 400w, ${photo[400]} 800w,
      ${photo[400]} 1300w, ${photo[800]} 1900w, ${photo[3600]} 3600w`;
    },

    formatNumber(num) {
      return (num < 10) ? '0' + num.toString() : num.toString();
    },

    isEmptyArray(val) {
      return arrayIsEmpty(val);
    },
  },
})
export default class AboutDesign extends Vue {}
